// components
import Link from '/react4xp/components/Link'

// utils
import { tel, mailto } from '/react4xp/utils/functions'

// types
interface Props {
    firstColumn?: {
        title: string
        phone: {
            label: string
            phone: string
        }
        email: {
            label: string
            url: string
        }
        addresses: {
            label: string
            url: string
            isExternal: boolean
        }
        adressText: string
    }
    secondColumn?: {
        title: string
        groupLinks: {
            links: {
                label: string
                url: string
            }[]
        }[]
    }
    thirdColumn?: {
        title: string
        social: {
            label: string
            url: string
        }[]
    }
}

// css
import './index.scss'

export default function Footer({
    firstColumn = {
        title: 'NLA Høgskolen',
        phone: {
            label: 'Tlf:',
            phone: '+4721969580'
        },
        email: {
            label: 'Send epost',
            url: 'info@example.com'
        },
        addresses: {
            label: 'Alle adresser',
            url: '#',
            isExternal: false
        },
        adressText: `
            Organisasjonsnr. <a href='#'>995 189 186</a><br />
            Kontonummer: <a href='#'>8220 02 88625</a><br />
            Vipps: 20913<br />
            <a href='#'>Bli giver</a>
        `
    },
    secondColumn = {
        title: 'Nyttige lenker',
        groupLinks: [
            {
                links: [
                    {
                        label: 'Studier',
                        url: '#'
                    },
                    {
                        label: 'Forskning',
                        url: '#'
                    },
                    {
                        label: 'Om oss',
                        url: '#'
                    }
                ]
            },
            {
                links: [
                    {
                        label: 'Personvern',
                        url: '#'
                    }
                ]
            }
        ]
    },
    thirdColumn = {
        title: 'Følg oss',
        social: [
            {
                label: 'Facebook',
                url: 'https://facebook.com/nlahogskolen'
            },
            {
                label: 'Twitter',
                url: 'https://twitter.com/nlahogskolen'
            },
            {
                label: 'Instagram',
                url: 'https://instagram.com/nlahogskolen'
            },
            {
                label: 'Snapchat',
                url: 'https://snapchat.com/'
            },
            {
                label: 'Linkedin',
                url: 'https://no.linkedin.com/edu/nla-h%C3%B8gskolen-22655'
            }
        ]
    }
}: Props) {
    return (
        <footer className='footer-component' data-footer>
            <div className='container'>
                <div className='row'>

                    <div className='col-lg-4 footer-component__first-column'>
                        
                        {firstColumn?.title && (
                            <p className='h3'>
                                {firstColumn?.title}
                            </p>
                        )}

                        <div className='footer-component__contact-details'>

                            {firstColumn?.phone && (
                                <Link
                                    className='body'
                                    href={tel(firstColumn?.phone?.phone)}
                                    label={{
                                        noUnderline: firstColumn?.phone?.label,
                                        underline: firstColumn?.phone?.phone
                                    }}
                                    icon={{
                                        type: 'phone',
                                        iconFirst: true
                                    }}
                                />
                            )}

                            {firstColumn?.email && (
                                <Link
                                    className='body'
                                    href={mailto(firstColumn?.email?.url)}
                                    label={{
                                        underline: firstColumn?.email?.label
                                    }}
                                    icon={{
                                        type: 'envelope',
                                        iconFirst: true
                                    }}
                                />
                            )}

                            {firstColumn?.addresses && (
                                <Link
                                    className='footer-component__address-link body'
                                    href={firstColumn?.addresses?.url}
                                    isExternal={firstColumn?.addresses?.isExternal}
                                    label={{
                                        underline: firstColumn?.addresses?.label
                                    }}
                                />
                            )}

                            {firstColumn?.adressText && (
                                <div
                                    className='footer-component__address-text body-small'
                                    dangerouslySetInnerHTML={{ __html: firstColumn?.adressText }}
                                    suppressHydrationWarning
                                />
                            )}

                        </div>

                    </div>

                    <div className='col-lg-4 footer-component__second-column'>
                        
                        {secondColumn?.title && (
                            <p className='h3'>
                                {secondColumn?.title}
                            </p>
                        )}

                        <div className='footer-component__links-list'>

                            {secondColumn?.groupLinks?.map((item, i) => (
                                item?.links?.map((link, j) => (
                                    <Link
                                        key={`${i}-${j}`}
                                        className='footer-component__link body'
                                        href={link?.url}
                                        label={{
                                            underline: link?.label
                                        }}
                                    />
                                ))
                            ))}

                        </div>

                    </div>

                    <div className='col-lg-4 footer-component__third-column'>
                        
                        {thirdColumn?.title && (
                            <p className='h3'>
                                {thirdColumn?.title}
                            </p>
                        )}

                        <div className='footer-component__social-list'>

                            {thirdColumn?.social?.map((item, i) => (
                                <Link
                                    key={i}
                                    href={item?.url}
                                    isExternal
                                    className='footer-component__social-link body'
                                    label={{
                                        underline: item?.label
                                    }}
                                />
                            ))}
                        </div>

                    </div>

                </div>
            </div>
        </footer>
    )
}